// extracted by mini-css-extract-plugin
export var alignCenter = "_7k-d";
export var bannerShown = "_7k-6";
export var buttonContent = "_7k-0";
export var cardList = "_7k-1";
export var centerContent = "_7k-2";
export var chevron = "_7k-3";
export var closePanelButton = "_7k-k";
export var conversationContextContainer = "_7k-l";
export var conversationDetailContainer = "_7k-4";
export var detailWrapper = "_7k-7";
export var dropdownButton = "_7k-e";
export var dropdownTitle = "_7k-9";
export var fullHeight = "_7k-5";
export var hidden = "_7k-a";
export var icon = "_7k-b";
export var mergeSuggestionWrapper = "_7k-m";
export var panel = "_7k-i";
export var portalButtonsWrapper = "_7k-c";
export var right = "_7k-j";
export var tableSummaryContainer = "_7k-8";
export var tableSummaryHeader = "_7k-g";
export var threeDotsButton = "_7k-f";
export var wide = "_7k-h";